module.exports = __webpack_public_path__ + "img/logoakava.23f5eb46.webp";